<template>
  <TrackingServiceForm :account-id="accountId" />
</template>

<script>
import TrackingServiceForm from '@/components/Application/Manage/Account/TrackingServiceForm'

export default {
  components: {
    TrackingServiceForm
  },
  data () {
    return {
      accountId: this.$route.params.accountId,
      breadcrumb: {
        name: 'Track My Parcel',
        route: { name: 'manage-accounts-account-configurations-trackingservices', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
